import { fuzzySearchResults } from './closestMatchOnKeyFuzzySearchHelpers';

function jobTitleClosestMatchOnKeyName<
  T extends { key: string; value: string }
>(data: T[]): string | null {
  const jobTitleMatchTerm = 'job';

  let jobMatch = data?.find((x) => x.key.toLowerCase() === jobTitleMatchTerm);

  if (!jobMatch) {
    jobMatch = fuzzySearchResults(jobTitleMatchTerm, data, 50)[0]?.data ?? null;
  }
  if (jobMatch) {
    return jobMatch.value.toLowerCase();
  }

  return null;
}

export default jobTitleClosestMatchOnKeyName;
